import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import {
  useGetIndividualCounselingProjectQuery,
  useGetIndividualCounselingProjectContractsListQuery,
  useGetDivisionQuery,
} from "../../features/api";
import { IndividualCounselingProjectContract } from "../../features/api-interfaces";
import {
  DivisionDict,
  getDivisionItems,
  getDivisionLabel,
} from "../default-constants";
import { IndividualCounselingProjectForm } from "./Main";

export const Update = () => {
  // 情報取得API呼び出し
  const { individualConsultationNo } = useParams();
  const IndividualCounselingProjectIndividualConsultationNo =
    individualConsultationNo as string;
  const { data: IndividualCounselingProjectCompany, refetch: refetch1 } =
    //個別相談案件の基本情報の方を取得する。
    useGetIndividualCounselingProjectQuery(
      IndividualCounselingProjectIndividualConsultationNo
    );

  const {
    data: IndividualCounselingProjectContract,
    isFetching,
    refetch: refetch2,
  } =
    //基本情報に紐づく個別相談案件相談内容を取得
    useGetIndividualCounselingProjectContractsListQuery(
      IndividualCounselingProjectIndividualConsultationNo
    );
  // 共通データを取得
  // 区分取得API呼び出し(親区分コード：3:契約サービス区分コード)
  const { data: contractServiceDivisions } = useGetDivisionQuery("3");

  // 一覧データの加工
  const [listData, setListData] = useState(
    [] as IndividualCounselingProjectContract[]
  );

  useEffect(() => {
    refetch1();
    refetch2();
  }, [refetch1, refetch2]);

  useEffect(() => {
    const contractServiceKbnItems: DivisionDict[] = getDivisionItems(
      contractServiceDivisions
    );
    const IndividualCounselingProjectContractsList =
      IndividualCounselingProjectContract
        ? IndividualCounselingProjectContract.map((item) => ({
            ...item,
            contractServiceName: getDivisionLabel(
              contractServiceKbnItems,
              item.contractServiceCode
            ),
          }))
        : [];
    setListData(IndividualCounselingProjectContractsList);
  }, [IndividualCounselingProjectContract, contractServiceDivisions]);
  return (
    <IndividualCounselingProjectForm
      IndividualCounselingProjectCompanyData={
        IndividualCounselingProjectCompany
      }
      IndividualCounselingProjectContractData={listData}
      individualConsultationNo={individualConsultationNo}
      isFetching={isFetching}
    />
  );
};
